import { Context } from '@alltrails/shared/types/context';
import usePathname from 'hooks/usePathname';
import { Page } from 'components/shared/Page/Page';
import Router from '@alltrails/shared/components/ReactRouter';

type PressProps = {
  context: Context;
};

const Press = ({ context }: PressProps): JSX.Element => {
  const fullpath = usePathname();

  return (
    <div>
      <Page context={context}>
        <Router fullpath={fullpath}>{/* TODO Add press page content here */}</Router>
      </Page>
    </div>
  );
};

export default Press;
